// extracted by mini-css-extract-plugin
module.exports = {"desc":"order-modal_desc__3hmvS","cancelContent":"order-modal_cancelContent__-I7Je","cancelContentItem":"order-modal_cancelContentItem__1MyNE"};